export default __webpack_public_path__ + "90402ff90cdd38f319c3942b0078be97.png";